module.exports = __webpack_public_path__ + "static/media/cleo-mobile-411x93.b856df4c.jpg";